import React from "react";
import RcDropdown from "../../_rc-dropdown-1.4.8/src";

export default class Dropdown extends React.Component {
  static defaultProps = {
    transitionName: "slide-up",
    prefixCls: "ant-dropdown",
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1
  };

  render() {
    return (
      <RcDropdown
        ref="rcdropdown"
        {...this.props}
        ecId={`${this.props.ecId}_RcDropdown@04jjjo`}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/dropdown/dropdown.jsx